import React from 'react';
import {
  Card,
  CardSection,
  Grid,
  GridColumn,
  GridRow,
  Gutter,
  Paragraph,
  SectionHeader,
  SmallHeader,
  CardHeader,
  EmptyLayout,
  ClientEngagementsDetailsContent,
  ClientContacts,
  useApi,
  LayoutItem,
  Layout,
  CondensedLarge,
  ReadonlyTextarea,
} from '@axiom/ui';

import EngagementWindowIcon from '../../public/svg/engagement-window-icon.svg';
import { useUserAccountData } from '../../hooks/useUserAccountData';
import { useEngagementTalentData } from '../../hooks/useEngagementTalentData';
import { TaxonomyApi } from '../../api/taxonomy-api';
import { ClientEngagementStartNewProject } from '../ClientEngagementStartNewProject/ClientEngagementStartNewProject';
import { EditEngagementButton } from '../EditEngagementButton/EditEngagementButton';

export const MyEngagementsItemDetails = () => {
  const { account, user } = useUserAccountData();
  const { submission } = useEngagementTalentData({ account });
  const [{ data: taxonomy }] = useApi(TaxonomyApi.readTaxonomy());

  return (
    <Grid name="engagement-details-tab">
      <GridRow>
        <GridColumn largeScreenWidth={8} smallScreenWidth={12}>
          <Gutter bottom="16px">
            {submission ? (
              <Card name="SUBMISSION_DETAILS">
                <CardHeader>
                  <Layout position="space-between">
                    <LayoutItem>
                      <SmallHeader name="JOB_NAME">
                        {submission.jobName}
                      </SmallHeader>
                    </LayoutItem>
                  </Layout>
                </CardHeader>
                <CardSection>
                  <Layout position="middle space-between">
                    <SectionHeader>Engagement details</SectionHeader>
                    {submission.selfService && submission.editable ? (
                      <LayoutItem position="right">
                        <EditEngagementButton
                          name="edit-engagement"
                          account={account}
                          user={user}
                          pattern="secondary"
                          variation="minimal"
                        />
                      </LayoutItem>
                    ) : null}
                  </Layout>
                  <Gutter bottom="16px" />
                  <ClientEngagementsDetailsContent
                    submission={submission}
                    taxonomy={taxonomy}
                  />
                  {submission.selfService &&
                  submission.positions[0]?.description ? (
                    <>
                      <SectionHeader>Legal needs summary</SectionHeader>
                      <Gutter bottom="16px" />
                      <CondensedLarge>
                        <ReadonlyTextarea
                          name="LEGAL_SUMMARY_DESCRIPTION"
                          value={submission.positions[0].description}
                          formatting="modern"
                        />
                      </CondensedLarge>
                    </>
                  ) : null}
                </CardSection>
              </Card>
            ) : (
              <Card name="ENGAGEMENT_CARD">
                <CardSection>
                  <EmptyLayout
                    graphic={<EngagementWindowIcon />}
                    graphicPosition="right"
                  >
                    <SmallHeader>
                      Axiom is reviewing your engagement
                    </SmallHeader>
                    <Gutter bottom="16px" />
                    <Paragraph>
                      We are verifying a few details to ensure our legal talent
                      specialists have everything they need to find exactly what
                      you're looking for. While we do that you have some instant
                      matches to review.
                    </Paragraph>
                  </EmptyLayout>
                </CardSection>
              </Card>
            )}
          </Gutter>
        </GridColumn>
        <GridColumn largeScreenWidth={4} smallScreenWidth={12}>
          <Gutter bottom="16px">
            <ClientEngagementStartNewProject user={user} account={account} />
          </Gutter>
          <ClientContacts
            cxPartner={account.cxPartner}
            ownerUser={account.ownerUser}
          />
        </GridColumn>
      </GridRow>
    </Grid>
  );
};
